import axios from 'axios';

const getCnaesPage = params => axios.get('/open/cnaes/page', {
  params,
});

export default {
  getCnaesPage,
};
